import script from "./MeuLinkConvite.vue?vue&type=script&setup=true&lang=js"
export * from "./MeuLinkConvite.vue?vue&type=script&setup=true&lang=js"

import "./MeuLinkConvite.vue?vue&type=style&index=0&id=3c387388&scoped=true&lang=css"

import exportComponent from "E:\\LARAVEL\\diariodetreino pastas\\front\\diariodetreino-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c387388"]])

export default __exports__